module.exports = __webpack_public_path__ + "img/roadnodata.468a053b.png";